import { gql } from "@apollo/client"

export const INVITE_MEMBERS_TO_GROUP = gql`
  mutation inviteMemberToGroup($organizationId: ID!, $organizationGroupId: ID!, $users: [AddUserInput]!) {
    addUsersToGroup(organizationGroupId: $organizationGroupId, organizationId: $organizationId, users: $users) {
      updatedGroup {
        id
      }
    }
  }
`
